<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <!-- 新增公告 -->
    <template #ADDBULLETIN="{params,visible}">
      <div style="wdith:100%">
        <editor @input="editorChange" v-if="visible" v-model="params.content" />
      </div>
    </template>
    <!-- 公告详情 -->
    <template #SHOWBULLETIN="{params,visible}">
      <div style="max-height:80vh;overflow-y:auto;" v-if="visible">
        <div class="html-div" v-html="params.content"></div>
        <Row
          style="font-family:'仿宋' !important;"
          v-if="params.extends && params.extends.length"
        >
          <Col span="2">{{ $t("Appendix") }}：</Col>
          <Col span="22">
            <div v-for="(ex, idx) in params.extends" :key="'ex' + idx">
              <a class="extand-li" target="_blank" :href="$globalUrl + ex.src">
                {{ ex.name }}
              </a>
            </div>
          </Col>
        </Row>
      </div>
      <div style="display: flex;">
        <div style="color:#888;flex: 1;">
          <span style="margin-right:30px"
            >{{ $t("publisher") }}：{{ params.operate_name }}</span
          >{{ $t("bulletinTime") }}：{{ params.create_time }}
        </div>
        <Button
          @click="readBulletin(params)"
          v-if="!params.read_status"
          type="success"
        >
          {{ $t("read_to_confirmed") }}
        </Button>
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  operBulletin,
  addBulletin,
  getBulletinDetail
} from "@/api/operation_modules/bulletin";
import { uploadImg } from "@/api/public";
import cTable from "@/base/common/index";
import editor from "_c/tiny-editor";
import { readBulletin } from "@/api/operation_modules/bulletin";
export default {
  name: "bulletinBoard",
  components: {
    cTable,
    editor
  },
  async mounted() {},
  methods: {
    readBulletin(params) {
      params.read_status = true;
      readBulletin(params.id);
      this.$refs["table"].getModal("show").close();
    },
    handleUpload(file) {
      this.$refs["table"].getModal("add").params["files"].push(file);
      return false;
    },
    delUploadFile(files, index) {
      files.splice(index, 1);
    },
    editorChange(val) {
      this.$refs["table"]
        .getModal("add")
        .$refs["form"].$refs.form.validateField("content");
    }
  },
  data() {
    return {
      addId: 0,
      isRead: false,
      methods: {
        list: p => {
          return operBulletin(p);
        },
        addBulletin,
        detail: getBulletinDetail
      },
      modals: {
        add: {
          slots: ["ADDBULLETIN"],
          methods: {
            ok({ row, close, btn }) {
              // let data = new FormData();
              // for (const key in row) {
              //   if (key === "files" && row[key]) {
              //     for (var i = 0; i < row[key].length; i++) {
              //       data.append("files[]", row[key][i]); // 文件对象
              //     }
              //   } else if (key === "sys" && row[key]) {
              //     for (var i = 0; i < row[key].length; i++) {
              //       data.append("sys[]", row[key][i]); // 文件对象
              //     }
              //   } else {
              //     if (row[key]) {
              //       data.append(key, row[key]);
              //     }
              //   }
              // }
              if (row["extends"] && row["extends"].length) {
                row["extends"].forEach((el, idx) => {
                  if (
                    Object.prototype.toString.call(el) === "[object Object]"
                  ) {
                    row["extends"][idx] = el.src;
                  }
                });
              }
              if (this.addId) {
                row["id"] = this.addId;
              }
              row["method"] = row.id ? "put" : "post";
              row["status"] = btn.status;
              this.$page.handleRequestMethods("list", row, true).then(e => {
                this.$page.getList();
                if (btn.status == 2) {
                  close();
                  this.addId = 0;
                } else {
                  this.addId = e.payload.id;
                }
              });
            },
            preview({ row, close, btn }) {
							console.log(row);
              this.$page.getModal("show").open(row, function() {
                this.setTitle(row.title);
              });
            },
            cancel() {
              this.addId = 0;
            }
          },
          footer: {
            btns: [
              {
                name: this.$t("preview"),
                bind: {
                  type: "warning"
                },
                isVif: true,
                fnName: "preview"
              },
              {
                name: this.$t("order_save"),
                bind: {
                  type: "primary"
                },
                status: 1,
                isVif: true,
                fnName: "ok"
              },
              {
                name: this.$t("publish"),
                bind: {
                  type: "success"
                },
                status: 2,
                isVif: true,
                fnName: "ok"
              }
            ],
            ok: {
              isShow: true
            },
            cancel: {
              isShow: true
            }
          },
          config: {
            modalBind: {
              width: "880",
              // "class-name": "vertical-center-modal",
              draggable: true,
              sticky: true,
              scrollable: true,
              styles: {
                top: "30px"
              }
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  type: "string",
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              sys: [
                {
                  required: true,
                  type: "array",
                  message: "code cannot be empty",
                  trigger: "change"
                }
              ],
              content: [
                {
                  required: true,
                  type: "string",
                  message: "content cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ title: 24 }, { sys: 24 }, { content: 24 }, { files: 24 }],
          fields: [
            {
              key: "title",
              name: () => this.$t("bulletinTitle"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bulletinTitle");
              }
            },
            {
              name: () => this.$t("bulletinSys"),
              key: "sys",
              component: "Select",
              bind: {
                multiple: true
              },
              placeholder: () => this.$t("select") + this.$t("bulletinSys"),
              options: [
                { value: 1, label: this.$t("oms") },
                { value: 2, label: this.$t("portal") }
              ]
            },
            {
              name: () => this.$t("bulletinContent"),
              key: "content",
              solt: "ADDBULLETIN",
              placeholder: () => this.$t("enter") + this.$t("bulletinContent")
            },
            {
              name: () => this.$t("bulletinExtend"),
              key: "files",
              component: "Upload",
              placeholder: () => this.$t("upload") + this.$t("bulletinExtend"),
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx"
              },
              methods: {
                beforeUpload({ file, row }) {
                  let data = new FormData();
                  data.append("file", file); // 文件对象
                  uploadImg(data).then(res => {
                    if (res.data.code == 0) {
                      if (row["extends"]) {
                        row["extends"].push(res.data.payload);
                        row["files"].push(file);
                      } else {
                        row["extends"] = [res.data.payload];
                        row["files"] = [file];
                      }
                      console.log("row", row);
                    } else {
                      this.$Message["error"]({
                        background: true,
                        content: res.data.msg,
                        duration: 5
                      });
                    }
                  });
                  return false;
                }
              }
            }
          ]
        },
        show: {
          contentSlot: "SHOWBULLETIN",
          config: {
            listFn: "list",
            modalBind: {
              width: "750",
              draggable: true,
              sticky: true,
              scrollable: true,
              "class-name": "bulletin-tit"
            }
          },
          footer: {
            show: false
          }
        },
        detail: {
          footer: {
            show: false
          },
          config: {
            listFn: "detail",
            title: "detail",
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            modalBind: {
              width: "80%",
              styles: {
                top: "30px"
              }
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          table: {
            config: {
              align: "center",
              height: "630px"
            },
            header: {
              config: {
                custom: false
              },
              searchs: [
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  bind: {
                    type: "textarea",
                    rows: 1
                  },
                  component: "Input"
                }
              ]
            },
            footer: {
              show: true
            },
            fields: [
              {
                name: () => this.$t("accountNum"),
                key: "account"
              },
              {
                name: () =>
                  this.$t("user_name") + "/" + this.$t("company_name"),
                key: "name"
              },
              {
                name: () => this.$t("read_time"),
                key: "read_time",
                show: () => {
                  return this.isRead;
                }
              }
            ]
          }
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              }
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.$parent.addId = 0;
              console.log(this);
              this.getModal("add").open(
                {
                  content: "",
                  files: []
                },
                function() {
                  this.setTitle(this.$t("add"));
                }
              );
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("bulletinTitle"),
          key: "title",
          align: "center",
          minWidth: 150
        },
        {
          name: () => this.$t("bulletinSys"),
          key: "sys_name",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("oms") + this.$t("Unread") + this.$t("numPeople"),
          key: "staff_unread",
          align: "center",
          component: "Button",
          bind: {
            type: "error",
            size: "small"
          },
          minWidth: 120,
          methods: {
            click: ({ row }) => {
              console.log(this);
              this.isRead = false;
              this.$refs["table"]
                .getModal("detail")
                .open({ row }, function(params) {
                  this.pageConfig.data["type"] = 12;
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                  this.setTitle(
                    this.$t("oms") + this.$t("Unread") + this.$t("numPeople")
                  );
                });
            }
          }
        },
        {
          name: () => this.$t("oms") + this.$t("Read") + this.$t("numPeople"),
          key: "staff_readed",
          align: "center",
          component: "Button",
          bind: {
            type: "success",
            size: "small"
          },
          minWidth: 120,
          methods: {
            click: ({ row }) => {
              this.isRead = true;
              this.$refs["table"]
                .getModal("detail")
                .open({ row }, function(params) {
                  this.pageConfig.data["type"] = 11;
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                  this.setTitle(
                    this.$t("oms") + this.$t("Read") + this.$t("numPeople")
                  );
                });
            }
          }
        },
        {
          name: () =>
            this.$t("portal") + this.$t("Unread") + this.$t("numPeople"),
          key: "customer_unread",
          align: "center",
          component: "Button",
          bind: {
            type: "error",
            size: "small"
          },
          minWidth: 120,
          methods: {
            click: ({ row }) => {
              this.isRead = false;
              this.$refs["table"]
                .getModal("detail")
                .open({ row }, function(params) {
                  this.pageConfig.data["type"] = 22;
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                  this.setTitle(
                    this.$t("portal") + this.$t("Unread") + this.$t("numPeople")
                  );
                });
            }
          }
        },
        {
          name: () =>
            this.$t("portal") + this.$t("Read") + this.$t("numPeople"),
          key: "customer_readed",
          align: "center",
          component: "Button",
          bind: {
            type: "success",
            size: "small"
          },
          minWidth: 120,
          methods: {
            click: ({ row }) => {
              this.isRead = true;
              this.$refs["table"]
                .getModal("detail")
                .open({ row }, function(params) {
                  this.pageConfig.data["type"] = 21;
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                  this.setTitle(
                    this.$t("portal") + this.$t("Read") + this.$t("numPeople")
                  );
                });
            }
          }
        },
        {
          name: () => this.$t("publisher"),
          key: "operate_name",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("bulletinTime"),
          key: "create_time",
          align: "center",
          minWidth: 120
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("publish"),
              type: "publish",
              fnName: "publishFun",
              bind: {
                type: "success"
              },
              show({ row }) {
                return row.status == 1;
              }
            },
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "showFun",
              bind: {
                type: "primary"
              },
              show({ row }) {
                return row.status == 2;
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              show({ row }) {
                return row.is_del == 1;
              }
            }
          ],

          methods: {
            async showFun({ row }) {
              // console.log("showFun", row);
              // row["extends"] = row.extend
              this.getModal("show").open(row, function() {
                this.setTitle(row.title);
              });
            },
            publishFun({ row }) {
              if (row["extends"].length) {
                row["files"] = JSON.parse(JSON.stringify(row["extends"]));
              } else {
                row["files"] = [];
              }
              console.log("row", row);

              this.getModal("add").open(row, function() {
                this.setTitle(this.$t("add"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("bulletinTitle") +
                  "：" +
                  row.title +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete"
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style>
/* .bulletin-tit .ivu-modal-header-inner {
  text-align: center;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
} */
	.tox-tinymce-aux{
		z-index: 99999 !important;
	}
</style>
